/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */
import Vue from 'vue';

window.EventBus = new Vue();

window.mapsCallback = function () {
    EventBus.$emit('google-maps-ready');
};

/**
 * Modernizr tests touchevents.
 */
require('browsernizr/test/touchevents');
require('browsernizr/lib/addTest');
window.Modernizr = require('browsernizr');

window.page = require('page');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Zenscroll is a vanilla JavaScript library that enables animated vertical scrolling to
 * an element or position within your document or within a scrollable element. It can
 * also automatically smooth all scrolling within the same page.
 */

window.zenscroll = require('zenscroll');

/**
 * This is a buggyfill (fixing bad behavior), not a polyfill (adding missing behavior).
 * That said, it provides hacks for you to get viewport units working in old IE and
 * Android Stock Browser as well.
 */

window.MobileDetect = require('mobile-detect');

const md = new MobileDetect(window.navigator.userAgent);

if (md.os()) {
    require('viewport-units-buggyfill').init(); // eslint-disable-line
}

/**
 * Give our fellow console loggers some love!
 */

console.log('%c Made with 🖤 by 51North: https://51north.nl ', 'background: #fff; color: #000'); // eslint-disable-line
